<template>
  <div>
    <WhatIfControl @subcommand="subcommand"></WhatIfControl>
    <TimerControl @subcommand="subcommand"></TimerControl>
    <TeamStatusControl :subject="slide.settings.subject" type="answers"></TeamStatusControl>
  </div>
</template>

<script>
import BaseSlide from './BaseSlide';
import WhatIfControl from '../controls/WhatIfControl';
import TimerControl from "../controls/TimerControl";
import TeamStatusControl from "../controls/TeamStatusControl";

export default {
	name: 'WhatIfSlide',
	mixins: [BaseSlide],
	components: {
		WhatIfControl,
    TimerControl,
    TeamStatusControl,
	},
};
</script>

<style scoped></style>
